import './melgroupleonda3/style';
import FormStructure from './melgroupleonda3/form_structure';

export default FormStructure;